import { Link } from 'react-router-dom'

import { css, styled } from '@styles/theme'

export const CoursesStyles = {
	container: css({
		background: '$neutral30',
		padding: '24px',
		width: '100%',

		'&.AccordionTrigger': {
			color: 'red',
		},

		'@sm': {
			padding: '8px 65px 8px 61px',
		},
	}),
	title: css({
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: '19px',
	}),
	content: css({
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		marginTop: 58,
	}),
	contentLeft: css({
		width: '100%',
		display: 'flex',
		flexDirection: 'column',
		alignItems: 'center',
		gap: 32,

		'@md': {
			flexDirection: 'row',
		},
	}),
	checkbox: css({
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
		padding: '11px 19px',
		alignItems: 'center',
		background: '$neutral10',
		height: 43,
		borderRadius: 12,
		border: '1px solid $neutral50',
		'& p': {
			fontSize: 14,
			fontWeight: '$medium',
			color: '$neutral150',
		},

		'@md': {
			maxWidth: 223,
		},
	}),
	LinkButton: styled(Link, {
		cursor: 'pointer',
		display: 'flex',
		justifyContent: 'space-between',
		alignItems: 'center',
		gap: '20px',

		svg: {
			width: '19px',
			height: '19px',
			color: '$blue20',
		},

		button: {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			width: '33px',
			height: '33px',
			border: '1px solid $blue20',
			borderRadius: '50%',
		},

		'& .buttonL': {
			svg: {
				position: 'relative',
				left: '2px',
			},
		},

		'& .buttonR': {
			svg: {
				position: 'relative',
				left: '-2px',
			},
		},

		variants: {
			disabled: {
				true: {
					color: '$disabled',
					pointerEvents: 'none',
					svg: {
						color: '$disabled',
					},
					p: {
						color: '$disabled',
					},
					button: {
						borderColor: '$disabled',
					},
				},
			},
		},
	}),

	containerMobileLink: css({
		width: '100%',
		display: 'flex',
		justifyContent: 'space-between',
	}),

	containerShow: css({
		display: 'flex',
		flexDirection: 'column',
		gap: '14px',
		padding: '24px',
		marginTop: '20px',

		background: '$neutral10',
		borderRadius: '12px',
		border: '1px solid $neutral50',
	}),

	containerTitleShow: css({
		display: 'flex',
		paddingBottom: '8px',
		borderBottom: '1px solid #D9D9D9',
		justifyContent: 'space-between',
	}),

	containerDescription: css({
		p: {
			_font: 'normal',
			fontSize: '$lg',
			fontWeight: 400,
			lineHeight: '26px',
			color: '$neutral160',
			paddingTop: '10px',
			marginBottom: '1rem',

			strong: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 700,
				lineHeight: '19px',
				color: '$neutral160',
			},

			span: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 400,
				lineHeight: '26px',
				color: '$neutral160',
			},
		},

		hr: {
			margin: '10px 0px',
		},

		a: {
			cursor: 'pointer',
			color: '$blue20',
		},

		img: {
			width: '100%',
		},

		ul: {
			paddingLeft: '24px',
			paddingTop: '10px',
			marginBottom: '1rem',
			strong: {
				_font: 'normal',
				fontSize: '$lg !important',
				fontWeight: 600,
				lineHeight: '24px',
				// color: '$neutral160',
			},
		},
	}),

	containerFiles: css({
		display: 'flex',
		flexWrap: 'wrap',
		gap: '20px',
		marginTop: '10px',
		paddingTop: '23px',

		borderTop: '1px solid $neutral50',
	}),

	containerActionBar: css({
		display: 'flex',
		alignItems: 'center',
		flexWrap: 'wrap',
		gap: '55px',
		width: '100%',
		minHeight: ' 57px',
		padding: '16px',
		margin: '32px 0px',

		background: '$neutral10',
		border: '1px solid $neutral50',
		borderRadius: '12px',

		cursor: 'pointer',
	}),
}
